import React, { ReactNode } from "react";
import { cn } from "@/utils/utils";

interface Props {
  isOpen: boolean;
  children: ReactNode;
  className?: string;
}

const PushDrawer: React.FC<Props> = ({ isOpen, children, className }) => (
  <div
    className={cn(
      "flex flex-col border-l transition-all duration-300 ease-in-out",
      isOpen
        ? "w-[45%] overflow-y-auto border-l-[0.5px] border-border-border1"
        : "w-0 overflow-hidden border-transparent",
      className,
      // merged last so no consumer className can strip the positioned ancestor the closed content needs
      "relative"
    )}
    data-test="push-drawer"
  >
    {/* Closed, the content leaves the flow so it can't stretch the row it shares with the tab content */}
    <div
      className={cn(
        "flex min-h-0 flex-1 flex-col",
        !isOpen && "absolute inset-0"
      )}
      data-test="push-drawer-content"
    >
      {children}
    </div>
  </div>
);

export default PushDrawer;
